import { dictionaryFromBuffer, type SetDictionary } from '@scrabble-daily/engine';
import wordsBinUrl from '@scrabble-daily/dict/compiled/words.bin?url';

let inFlight: Promise<SetDictionary> | null = null;

/**
 * The compiled wordlist ships as a static asset (spec 9) so guest play and
 * the live preview validate moves entirely client-side. Loaded once and held
 * for the session.
 */
export function loadDictionary(): Promise<SetDictionary> {
  inFlight ??= fetch(wordsBinUrl)
    .then((res) => {
      if (!res.ok) throw new Error(`dictionary fetch failed: ${res.status}`);
      return res.arrayBuffer();
    })
    .then((buf) => dictionaryFromBuffer(new Uint8Array(buf)));
  return inFlight;
}
